import { render, staticRenderFns } from "./VirtualServerPricing.vue?vue&type=template&id=66184869&scoped=true&"
import script from "./VirtualServerPricing.vue?vue&type=script&lang=js&"
export * from "./VirtualServerPricing.vue?vue&type=script&lang=js&"
import style0 from "./VirtualServerPricing.vue?vue&type=style&index=0&id=66184869&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66184869",
  null
  
)

export default component.exports